module.exports = __webpack_public_path__ + "img/icon-ranking-1@3x.c4234927.png";